import servise from '@/router/axios'

// 修改当前用户状态
export const updateStatus = (data) => {
  return servise({
    url: '/admin/update/status',
    method: 'PUT',
    data
  })
}

// 获取角色列表
export const sysUserRoleList = (params) => {
  return servise({
    url: '/sysUserRole/list',
    method: 'get',
    params
  })
}

// 获取角色权限列表
export const sysUserRoleMenuList = (params) => {
  return servise({
    url: '/sysUserRole/role/menu/list',
    method: 'get',
    params
  })
}

// 添加新用户
export const addAdmin = (data) => {
  return servise({
    url: '/admin/add',
    method: 'post',
    data
  })
}
// 修改账号信息
export const updateAdmin = (data) => {
  return servise({
    url: '/admin/update',
    method: 'PUT',
    data
  })
}


// 账号管理——客户管理列表
export const clientList = (data) => {
  return servise({
    url: '/accountConf/list',
    method: 'post',
    data
  })
}

// 账号管理——客户管理修改
export const editClient = (data) => {
  return servise({
    url: '/accountConf/edit',
    method: 'post',
    data
  })
}